import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
/**
 * Default display text for the Member Transaction List component.
 */
export const defaultMemberTransactionListDisplayText = {
    tableColumnDateHeaderLabel: 'Date',
    tableColumnDetailsHeaderLabel: 'Details',
    tableColumnTotalsHeaderLabel: 'Points',
    buttonLoadMoreLabel: 'Load more',
    failedToLoadDataTitle: 'Sorry, something went wrong.',
    failedToLoadDataMessage: 'Refresh your browser to try loading your transactions again.',
    noTransactionsTitle: "You haven't made any transactions yet.",
    noTransactionsMessage: 'Your future transactions will be shown here.'
};
export const memberTransactionListDisplayTextValidator = Validator.object({
    tableColumnDateHeaderLabel: nonEmptyStringValidator,
    tableColumnDetailsHeaderLabel: nonEmptyStringValidator,
    tableColumnTotalsHeaderLabel: nonEmptyStringValidator,
    buttonLoadMoreLabel: nonEmptyStringValidator,
    failedToLoadDataTitle: nonEmptyStringValidator,
    failedToLoadDataMessage: nonEmptyStringValidator,
    noTransactionsTitle: nonEmptyStringValidator,
    noTransactionsMessage: nonEmptyStringValidator
});
